module.exports = __webpack_public_path__ + "media/battlewin.af9ed33d.ogg";